import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import {Observable, Subscription, take, timeout, catchError, of, filter} from "rxjs";
import { ToastService } from "../../services/toast.service";
import { UserService } from "../../services/user.service";
import { select, Store } from "@ngrx/store";
import {map} from "rxjs/operators";
import { AppState } from "../../state/reducers";
import { selectLoginSuccess } from "../../state/auth/auth.selectors";

@Injectable({
  providedIn: "root",
})
export class AuthGuard  {

  // private isLoggedInSubscription: Subscription;
  isLoggedIn: false

  constructor(
    private userService: UserService,
    private router: Router,
    private toastService: ToastService,
    private store: Store<AppState>
  ) {}

  canActivate(): Observable<boolean> {
    return this.store.select(selectLoginSuccess).pipe(
      // Wait for isLoggedIn to be true, or take first value after short delay
      filter(data => data.isLoggedIn === true),
      take(1), // Take the first true value
      timeout(3000), // 3 second timeout
      map(() => true), // User is logged in, allow navigation
      catchError((error) => {
        // Timeout or error - user not logged in
        console.error('[AuthGuard] Timeout or not logged in, redirecting to /login', error);
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }

  /*
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    // Store the attempted URL for redirection after login
    this.userService.redirectUrl = state.url;

    if (this.userService.loggedIn) {
      return true;
    }

    // Redirect to the login page
    return this.router.navigate(['/login']);
  }
  */
}
